import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockImageAndTextData {
  title?: BlockComponentText;
  description?: BlockComponentText;
  mainImage?: BlockComponentImage;
  backgroundImage?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockImageAndTextData {
  export function make(title?: string, description?: string, mainImage?: string, backgroundImage?: string): BlockImageAndTextData {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      description: description ? BlockComponentText.make(description) : undefined,
      mainImage: BlockComponentImage.make(mainImage),
      backgroundImage: BlockComponentImage.make(backgroundImage),
    };
  }

  export function getDefault(image = '', title = 'タイトル', description = 'テキストを入力してください'): BlockImageAndTextData {
    return make(
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      `<p><strong style="font-size: 20px;">${description}</strong></p>`,
      image,
    );
  }
}

export default BlockImageAndTextData;
